<ng-container [formGroup]="childForm">
    <ng-container *ngFor="let question of qQuestions;let i=index">
        <!-- Header Text Row -->
        <ng-container *ngIf="question?.headerTxt?.length > 0">
            <ng-container *ngIf="DispOnlyInd === 'N';else notDispOnlyInd">
                <tr>
                    <td colspan="4">
                        <p class="boldlbl">{{question?.headerTxt | uppercase}}</p>
                    </td>
                </tr>
            </ng-container>
            <ng-template #notDispOnlyInd>
                <tr>
                    <td width="5%">&nbsp;</td>
                    <td colspan="3" class="boldlbl">
                        <p>{{question?.headerTxt | uppercase}}</p>
                    </td>
                </tr>
            </ng-template>
        </ng-container>
        <!-- Notes Row -->
        <ng-container *ngIf="question?.notes?.length > 0 && DispOnlyInd === 'N'">
            <!-- <tr style="background-color: #CDCD9A"> -->
            <tr style="background-color: #bfe0ff">
                <td width="5%">&nbsp;</td>
                <td colspan="3">{{question?.notes}}</td>
            </tr>
        </ng-container>
        <!-- Question Row -->
        <tr>
            <td *ngIf="question?.requiredFlag === 'Y' && DispOnlyInd === 'N'; else notRequired" width="5%">
                <p class="errorMsg text-center"><strong>*</strong></p>
            </td>
            <ng-template #notRequired>
                <td width="5%">&nbsp;</td>
            </ng-template>
            <ng-container *ngIf="!question?.dependency;else dependency">
                <td width="70%" colspan="2">
                    <p>
                        <ng-container *ngIf="DispSeqInd === 'Y'">
                            <ng-container *ngIf="DispSeqType === 'A'; else dispSeqTypeN">
                                <!-- Display sequence as alphabets -->
                                {{getTRCAlphaList(i)}}.&nbsp;&nbsp;
                            </ng-container>
                            <ng-template #dispSeqTypeN>
                                <!-- Display sequence as numbers -->
                                {{i+1}}.&nbsp;&nbsp;
                            </ng-template>
                        </ng-container>
                        {{question?.questionTxt}}
                    </p>
                </td>
            </ng-container>
        
            <ng-template #dependency>
                <td width="5%">&nbsp;</td>
                <td width="65%" style="vertical-align:top;">
                    <p>
                        >&nbsp;&nbsp;{{question?.questionTxt}}
                    </p>
                </td>
            </ng-template>
         
            <!-- answer section -->
            <td class="label1" nowrap="nowrap" style="vertical-align:top;">
                <!-- display answers only -->
                <ng-container *ngIf="DispOnlyInd === 'Y';else notDisplayOnly">
                    <span style="text-decoration:underline">
                        <ng-container [ngSwitch]="question.questionType">
                            <span *ngSwitchCase="'YES/NO'" class="boldlbl">
                                <ng-container [ngSwitch]="question.answerTxt">
                                    <span *ngSwitchCase="'Y'">
                                        YES
                                    </span>
                                    <span *ngSwitchCase="'N'">
                                        NO
                                    </span>
                                    <span *ngSwitchDefault>
                                        ---
                                    </span>
                                </ng-container>
                            </span>
                            <span *ngSwitchCase="'YES/NO/N/A'" class="boldlbl">
                                <ng-container [ngSwitch]="question.answerTxt">
                                    <span *ngSwitchCase="'Y'">
                                        YES
                                    </span>
                                    <span *ngSwitchCase="'N'">
                                        NO
                                    </span>
                                    <span *ngSwitchCase="'N/A'">
                                        N/A
                                    </span>
                                    <span *ngSwitchDefault>
                                        ---
                                    </span>
                                </ng-container>
                            </span>
                            <span *ngSwitchCase="'FREEFORM'">
                                <span *ngIf="question.answerTxt.length>0;else noFreeformTxt" class="boldlbl">{{question.answerTxt}}</span>
                                <ng-template #noFreeformTxt>---</ng-template>
                            </span>
                            <span *ngSwitchCase="'DATE'">
                                <span *ngIf="question.answerTxt.length>0" class="boldlbl">{{question.answerTxt}}</span>
                            </span>
                            <span *ngSwitchCase="'TEXTAREA'">

                            </span>
                        </ng-container>
                    </span>
                </ng-container>
                <ng-template #notDisplayOnly>
                    <ng-container *ngIf="question.questionType === 'YES/NO' ">
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">Yes</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input"   [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="Y"
                                [checked]="question.answerTxt === 'Y'" (change)="isSelected(question,$event)" 
                                />
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">No</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input"    [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="N"
                                [checked]="question.answerTxt === 'N'" (change)="isSelected(question,$event)" 
                                />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'YES/NO/N/A'">
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">Yes</label>
                            &nbsp;&nbsp; <input type="radio" class="form-check-input"  [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="Y"
                                [checked]="question.answerTxt === 'Y'" (change)="isSelected(question,$event)"/>
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">No</label>
                            &nbsp;&nbsp;<input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="N"
                                [checked]="question.answerTxt === 'N'" (change)="isSelected(question,$event)"/>
                        </div>
                        <div class="form-check-inline">
                            <label class="form-check-label boldlbl">N/A</label>
                            &nbsp;&nbsp;<input type="radio" class="form-check-input" [attr.name]="question.metaName"
                                formControlName="{{question.metaName}}" value="NA"
                                [checked]="question.answerTxt === 'NA'" (change)="isSelected(question,$event)"/>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'FREEFORM'">
                        <div class="form-group">
                            <input type="text" [attr.name]="question.metaName" class="form-control form-control-sm"
                            formControlName="{{question.metaName}}" value=""
                            [maxlength]="question.textFieldMaxLength" />
                        </div>
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'DATE'">
                        <input type="date" [attr.name]="'dt'+question.metaName" maxlength="10"
                            class="form-control form-control-sm" formControlName="dt{{question.metaName}}"
                            [maxlength]="question.textFieldMaxLength" value="" />
                    </ng-container>
                    <ng-container *ngIf="question.questionType === 'TEXTAREA'">
                        <!-- if textarea display it in next row -->
                    </ng-container>
                </ng-template>
            </td>
        </tr>
 <tr *ngIf="isYes && question.answerTxt === 'Y' && isNextlevel && ( question.fcQuestions && question.fcQuestions.length)" style="width: 100%;">
		<td width="5%"></td>
		<td width="70%" colspan="2">
									<jhi-dsp-questions-answers-fclevel [qQuestions]="question.fcQuestions"
										[fcForm]="childForm"
										[DispOnlyInd]="DispOnlyInd" [DispSeqInd]="DispSeqInd" 
										(answerAdded)="update($event)" >
									</jhi-dsp-questions-answers-fclevel>
								</td>
	</tr>

<tr *ngIf="question.questionType === 'TEXTAREA'">
            <td width="5%">&nbsp;</td>
            <ng-container>
                <ng-container *ngIf="question?.dependency !== 0">
                    <td width="5%">&nbsp;</td>
                </ng-container>
                <td [attr.colspan]="question?.dependency === 0?2:1"
                    [ngClass]="{'w-70': question?.dependency === 0, 'w-65' : question?.dependency !== 0 }">
                    <ng-container *ngIf="DispOnlyInd === 'Y';else notDisplayOnly">
                        <textarea cols="50" class="form-control form-control-sm" rows="3"
                            readonly="readonly">{{question.answerTxt}}</textarea>
                    </ng-container>
                    <ng-template #notDisplayOnly>
                        <textarea cols="50" [attr.name]="question.metaName" class="form-control form-control-sm"
                            formControlName="{{question.metaName}}" rows="3"
                            [maxlength]="question.textFieldMaxLength">{{question.answerTxt}}</textarea>
                        <span style="font-size:10px; font-style:italic">You have {{
                            childForm.get(question.metaName).value | remainingTextCounter:
                            question.textFieldMaxLength}} characters remaining
                            for your entry.</span>
                    </ng-template>
                </td>
                <td>
                    <p></p>
                </td>
            </ng-container>
        </tr>
    </ng-container>
</ng-container>